import React from "react";

import {
  List,
  DataTable,
  TextField,
  TextInput,
  Edit,
  SimpleForm,
  EditButton,
  Create,
  TopToolbar,
  ColumnsButton,
  CreateButton,
} from "react-admin";

export const MetaDataList = () => (
  <List
    pagination={null}
    sort={{ field: "name", order: "ASC" }}
    actions={
      <TopToolbar>
        <CreateButton />
        <ColumnsButton />
      </TopToolbar>
    }
    storeKey={false}
    empty={false}
  >
    <DataTable rowClick={false} bulkActionButtons={false}>
      <DataTable.Col source="id" label="ID">
        <TextField source="id" label="ID" />
      </DataTable.Col>
      <DataTable.Col source="name" label="Name">
        <TextField source="name" label="Name" />
      </DataTable.Col>
      <DataTable.Col>
        <EditButton />
      </DataTable.Col>
    </DataTable>
  </List>
);

export const MetaDataEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="id" readOnly />
      <TextInput source="name" label="Name" />
    </SimpleForm>
  </Edit>
);

export const MetaDataCreate = () => (
  <Create redirect="list">
    <SimpleForm>
      <TextInput source="id" disabled />
      <TextInput source="name" label="Name" />
    </SimpleForm>
  </Create>
);
